module.exports = __webpack_public_path__ + "img/icon.aec4d2e1.png";